module.exports = __webpack_public_path__ + "static/media/round-clock.b318f885.png";